// Una acción del plan de crisis, en una línea.
//
// El círculo la mueve (sin empezar → en curso → hecha). El texto la abre en un
// popup con todo lo necesario para resolverla: el paso a paso, los contactos y
// el chat con la IA. La lógica del popup vive en AccionModal.

import React from 'react';
import styled from 'styled-components';
import {
  FaCheck, FaRegCircle, FaSpinner, FaTrash, FaChevronRight, FaMagic, FaPhone, FaRobot,
} from 'react-icons/fa';
import { TechButtonDanger, TechChip, borderSoft } from '../../styles/techComponents';

const OK = '#06d6a0';
const TIBIO = '#ffd166';

const Fila = styled.div`
  display: flex; align-items: flex-start; gap: 11px; padding: 10px 0;
  border-bottom: 1px solid ${borderSoft};
  &:last-child { border-bottom: none; }
`;

const Marca = styled.button`
  background: none; border: none; cursor: pointer; padding: 2px 0 0;
  color: ${(p) => (p.$hecha ? OK : p.$curso ? TIBIO : 'var(--text-secondary)')};
  font-size: 0.95rem; display: flex; flex-shrink: 0;
  &:disabled { opacity: 0.5; cursor: default; }
`;

const Cuerpo = styled.button`
  flex: 1; min-width: 0; text-align: left;
  background: none; border: none; padding: 0; cursor: pointer;
  font-family: inherit; color: inherit;
  text-decoration: ${(p) => (p.$hecha ? 'line-through' : 'none')};
  opacity: ${(p) => (p.$hecha ? 0.55 : 1)};
`;

const Titulo = styled.div` font-size: 0.9rem; color: var(--text-primary); line-height: 1.45; `;

const Sub = styled.div`
  font-size: 0.76rem; color: var(--text-secondary); margin-top: 3px;
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
`;

const Flecha = styled.span` color: var(--text-secondary); display: flex; margin-left: auto; align-self: center; `;

export default function AccionCrisis({ accion, ocupado, onCiclar, onBorrar, onAbrir }) {
  const hecha = accion.estado === 'hecha';
  const curso = accion.estado === 'en_curso';
  const nChat = Math.ceil((accion.chat?.length || 0) / 2);
  const nContactos = accion.contactos?.length || 0;

  return (
    <Fila>
      <Marca
        $hecha={hecha} $curso={curso} disabled={ocupado}
        onClick={() => onCiclar(accion)}
        aria-label={`Marcar "${accion.titulo}"`}
        title="Sin empezar → en curso → hecha"
      >
        {hecha ? <FaCheck /> : curso ? <FaSpinner /> : <FaRegCircle />}
      </Marca>

      <Cuerpo $hecha={hecha} onClick={() => onAbrir(accion)}>
        <Titulo>{accion.titulo}</Titulo>
        <Sub>
          {accion.prioridad === 'alta' && '🔴 '}
          {accion.detalle ? `${accion.detalle} · ` : ''}
          {accion.origen === 'kit' ? 'del plan' : 'a mano'}
          {accion.responsable ? ` · ${accion.responsable}` : ''}
          {accion.tiene_plan && <TechChip><FaMagic style={{ fontSize: '0.62rem' }} /> paso a paso</TechChip>}
          {nContactos > 0 && <TechChip><FaPhone style={{ fontSize: '0.62rem' }} /> {nContactos}</TechChip>}
          {nChat > 0 && <TechChip><FaRobot style={{ fontSize: '0.62rem' }} /> {nChat}</TechChip>}
        </Sub>
      </Cuerpo>

      <Flecha><FaChevronRight /></Flecha>

      <TechButtonDanger onClick={() => onBorrar(accion.id)} disabled={ocupado} title="Borrar">
        <FaTrash />
      </TechButtonDanger>
    </Fila>
  );
}
